import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { filter } from 'rxjs/operators';

const RETURN_URL_KEY = 'returnUrl';

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    constructor(private router: Router, private storageService: LocalStorageService) 
    {
        this.listenForNavigationEvents();
    }

    // Method for the Interceptor to retrieve the URL
    public getReturnUrl(): string | null
    {
        return this.storageService.retrieve(RETURN_URL_KEY);
    }    

    // Listen for successful navigation end events
    private listenForNavigationEvents(): void
    {
        // We only want to save the URL after a successful navigation completes
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) =>
            {
                // Save the full URL (path + query params + fragment).Ensure we DO NOT save the login route itself!
                if (!event.urlAfterRedirects.includes('/login'))
                {
                    this.storageService.store(RETURN_URL_KEY, event.urlAfterRedirects);
                }
            });
    }
}